<template>
  <div>
    <a-alert message="警告" type="error" closable  show-icon
             description="对部门和单位修改是高风险操作，修改和删除会导致对应部门的公示文件一起被删除，且该部门人员账号无法登录，请悉知！"/>
    <a-button @click="addGov()">添加部门</a-button>
    <a-divider/>
    <a-modal :visible="show.addGov" width="50%" ok-text="确认" cancel-text="取消" @ok="submitGovForm"
             @cancel="closeGovForm">
      <a-form-model :model="form.gov" :rules="rules.gov" :label-col="labelCol" :wrapper-col="wrapperCol" ref="govForm">
        <a-form-model-item label="ID" style="display: none">
          <a-input v-model="form.gov.id" disabled placeholder="新建时自动生成"/>
        </a-form-model-item>
        <a-form-model-item label="名称" prop="name">
          <a-input v-model="form.gov.name"/>
        </a-form-model-item>
        <a-form-model-item label="顺序" prop="sort">
          <a-input-number v-model="form.gov.sort"/>
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-bottom-button">
        <a-button :style="{ marginRight: '8px' }" @click="closeGovForm">关闭</a-button>
        <a-button type="primary" @click="submitGovForm">保存</a-button>
      </div>
    </a-modal>
    <a-modal :visible="show.addReg" width="50%" ok-text="确认" cancel-text="取消" @ok="submitRegForm"
             @cancel="closeRegForm">
      <a-form-model :model="form.reg" :rules="rules.reg" :label-col="labelCol" :wrapper-col="wrapperCol" ref="regForm">
        <a-form-model-item label="ID" style="display: none">
          <a-input v-model="form.reg.id" disabled placeholder="新建时自动生成"/>
        </a-form-model-item>
        <a-form-model-item label="部门" prop="governId1">
          <a-select v-model="form.reg.governId" disabled>
            <a-select-option v-for="item in govList" :key="item.id" :value='item.id'>
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="全称" prop="area">
          <a-input v-model="form.reg.area"/>
        </a-form-model-item>
        <a-form-model-item label="简称" prop="simpleName">
          <a-input v-model="form.reg.simpleName"/>
        </a-form-model-item>
        <a-form-model-item label="联系人" prop="people" v-if="false">
          <a-input v-model="form.reg.people"/>
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="phone" v-if="false">
          <a-input v-model="form.reg.phone"/>
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-bottom-button">
        <a-button :style="{ marginRight: '8px' }" @click="closeRegForm">关闭</a-button>
        <a-button type="primary" @click="submitRegForm">保存</a-button>
      </div>
    </a-modal>
    <a-table :data-source="govDataSource" key="id" :columns="govColumns" :pagination="pagination"
             @expand="openInnerTable" :expandedRowKeys="expanded">
      <span slot="action" slot-scope="text, record">
        <c-pop-button title="确定要删除吗" text="删除" type="danger" @click="removeGov(record)"/>
        <a-divider type="vertical"/>
        <a-button type="primary" size="small" @click="editGov(record)">编辑</a-button>
        <a-divider type="vertical"/>
        <a-button type="primary" size="small" @click="addReg(record)">添加单位</a-button>
      </span>
      <a-table slot="expandedRowRender" slot-scope="text" :columns="regColumns"
               :data-source="regDataSource" :pagination="false">
       <span slot="action" slot-scope="text, record">
        <c-pop-button title="确定要删除吗" text="删除" type="danger" @click="removeReg(record)"/>
        <a-divider type="vertical"/>
        <a-button type="primary" size="small" @click="editReg(record)">编辑</a-button>
      </span>
      </a-table>
    </a-table>

  </div>
</template>

<script>

import CPopButton from "@comp/c-pop-button";
import {initCPagination} from "@/views/component/C-Pagination";
import {CustomApis as api} from "@/api/CustomApis";

export default {
  name: "menus-list",
  components: {
    CPopButton,
  },
  data() {
    return {
      labelCol: {span: 5},
      wrapperCol: {span: 16},
      govColumns: [
        {
          dataIndex: 'name',
          title: '名称',
          width: '30%'
        },
        {
          dataIndex: 'sort',
          title: '显示顺序',
          width: '30%'
        },
        {
          dataIndex: 'action',
          title: '操作',
          scopedSlots: {customRender: 'action'},
          width: '50%'
        },
      ],
      regColumns: [
        {
          dataIndex: 'area',
          title: '名称',
          width: '40%'
        },
        {
          dataIndex: 'simpleName',
          title: '简称',
          width: '20%'
        },
        {
          dataIndex: 'action',
          title: '操作',
          scopedSlots: {customRender: 'action'},
          width: '40%'
        },
      ],
      govDataSource: [],
      regDataSource: [],
      pagination: initCPagination(this.changeIndex, this.changeSize),
      govList: [],
      rules: {
        gov: {
          name: [
            {required: true, message: '请输入名称', trigger: 'change'},
            {min: 2, max: 16, message: '长度为2-16个字符', trigger: 'change'},
            {whitespace: true, message: '请输入名称', trigger: 'change'}
          ],
          menusType: [
            {required: true, message: '类型不能为空', trigger: 'change'},
          ],
        },
        reg: {
          governId: [
            {required: true, message: '请选择部门', trigger: 'change'},
            {whitespace: true, message: '请选择部门', trigger: 'change'},
          ],
          area: [
            {required: true, message: '请输入名称', trigger: 'change'},
            {min: 2, max: 16, message: '长度为2-16个字符', trigger: 'change'},
            {whitespace: true, message: '请输入名称', trigger: 'change'}
          ],
          simpleName: [
            {required: true, message: '请输入名称', trigger: 'change'},
            {min: 2, max: 16, message: '长度为2-16个字符', trigger: 'change'},
            {whitespace: true, message: '请输入名称', trigger: 'change'}
          ],
          people: [
            {required: true, message: '请输入联系人', trigger: 'change'},
            {min: 2, max: 16, message: '长度为2-16个字符', trigger: 'change'},
            {whitespace: true, message: '请输入联系人', trigger: 'change'}
          ],
          phone: [
            {required: true, message: '请输入联系人电话', trigger: 'change'},
            {min: 2, max: 16, message: '长度为7-16个字符', trigger: 'change'},
            {whitespace: true, message: '请输入联系人电话', trigger: 'change'}
          ],

        },
      },
      form: {
        gov: {
          id: '',
          name: '',
          sort: '',
        },
        reg: {
          id: '',
          governId: '',
          area: '',
          simpleName: '',
          people: '',
          phone: '',
        },
      },
      show: {
        addGov: false,
        addReg: false,
      },
      expanded: []
    };
  },
  watch: {},
  activated() {
    this.getList()

  },
  mounted() {
  },
  methods: {
    changeIndex(pageIndex, pageSize) {
      let page = {
        pageIndex: pageIndex,
        pageSize: pageSize,
      }
      this.getList(page)
    },
    changeSize(current, pageSize) {
      let page = {
        pageIndex: current,
        pageSize: pageSize,
      }
      this.getList(page)
    },
    resetGovForm() {
      this.form.gov = {
        id: '',
        name: '',
        sort: '',
      }
    },
    resetRegForm() {
      this.form.reg = {
        governId: '',
        id: '',
        name: '',
      }
    },
    refreshData() {
      this.resetGovForm()
      this.resetRegForm()
      this.getList()
    },
    getList(page) {
      this.$http.get(api.getGovPage, {params: page}).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
          let format = function (data) {
            return data.map(e => {
              return {
                id: e.id,
                key: e.id,
                name: e.name,
                sort: e.sort,
                regions: e.regions
              }
            }).sort((a, b) => {
              return a.id - b.id
            });
          }
          this.govDataSource = format(result.data)
          if (this.expanded.length) {
            this.govDataSource.forEach(e => {
              if (e.id === this.expanded[0]) {
                this.regDataSource = e.regions
              }
            })
          }
          this.pagination.total = result.page.dataCount
          this.pagination.current = result.page.pageIndex
        }
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    getGovList() {
      this.$http.get(api.getGovList).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
          this.govList = result.data
        }
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    openInnerTable(expanded, row) {
      this.expanded = []
      if (expanded) {
        this.expanded = [row.id]
        this.regDataSource = row.regions
      }
    },
    removeGov(e) {
      this.$http.post(`${api.delGov}/${e.id}`).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        this.refreshData()
        this.$message.success(result.message)
      }).catch(function (error) {
        console.log('请求出现错误:', error);
      });
    },
    removeReg(e) {
      this.$http.post(`${api.delReg}/${e.id}`).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        this.refreshData()
        this.$message.success(result.message)
      }).catch(function (error) {
        console.log('请求出现错误:', error);
      });
    },
    addGov() {
      this.show.addGov = true
    },
    addReg(e) {
      this.form.reg.governId = e.id
      this.show.addReg = true
      this.getGovList()
    },
    editGov(e) {
      this.form.gov = e
      this.show.addGov = true
    },
    editReg(e) {
      this.getGovList()
      this.form.reg = e
      this.show.addReg = true
    },
    closeGovForm() {
      this.show.addGov = false
      this.refreshData()
    },
    closeRegForm() {
      this.show.addReg = false
      this.refreshData()
    },
    submitGovForm() {
      this.$refs.govForm.validate((e) => {
        if (!e) {
          return
        }
        this.$http.post(api.saveGov, this.form.gov).then(result => {
          if (result.status !== 200) {
            this.$message.error(result.message);
            return;
          }
          this.closeGovForm()
        }).catch(function (error) {
          console.error('出现错误:', error);
        });
      })
    },
    submitRegForm() {
      this.$refs.regForm.validate((e) => {
        if (!e) {
          return
        }
        this.$http.post(api.saveReg, this.form.reg).then(result => {
          if (result.status !== 200) {
            this.$message.error(result.message);
            return;
          }
          this.closeRegForm()
        }).catch(function (error) {
          console.error('出现错误:', error);
        });
      })
    },
  }
}
</script>

<style scoped>
.drawer-bottom-button {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
